export default __webpack_public_path__ + "static/media/goshen63.af56b3d8.jpg";